import React from 'react';

const FinancialPlanningDivorceBottomline = () => {
  const benefits = [
    {
      title: "Asset Preservation Strategy",
      description: "Implementing a structured approach to asset division that considers tax implications, liquidation costs, and long-term value preservation maximizes your post-divorce financial position beyond the simple numerical split."
    },
    {
      title: "Future Income Mapping",
      description: "Developing a comprehensive post-divorce budget and income plan that accounts for support payments, career transitions, and changing expenses provides financial clarity during a period of significant life adjustment."
    },
    {
      title: "Strategic Settlement Negotiation",
      description: "Prioritizing financial assets based on liquidity needs, growth potential, and tax consequences rather than emotional attachment ensures decisions that support long-term financial stability beyond the divorce."
    },
    {
      title: "Financial Identity Reconstruction",
      description: "Establishing independent credit, banking relationships, and financial documentation creates a solid foundation for financial autonomy while protecting against lingering financial entanglements with your former spouse."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic Divorce Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancialPlanningDivorceBottomline;